import React from 'react'
import {Route} from 'react-router'
import TrafficInsightView from 'views/TrafficInsightView'

export default trackRoute => {
  return (
    <Route
      path='traffic'
      title='Traffic Trends'
      component={TrafficInsightView}
      onEnter={trackRoute('traffic')}
      disableDatePicker
    />
  )
}



// WEBPACK FOOTER //
// ./client/routes/traffic.js